import { IconName } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { StatusType, Tag } from '@ardoq/status-ui';
import { Text } from '@ardoq/typography';

export type WidgetPopoverProps = {
  tooltipText: string;
} & (
  | {
      canExploreDatasource: false;
    }
  | {
      canExploreDatasource: true;
      filterProps: {
        show: boolean;
        text: string;
      };
    }
);

export const WidgetPopover = (props: WidgetPopoverProps) =>
  props.canExploreDatasource ? (
    <FlexBox gap="small" align="center">
      <Text>{props.tooltipText}</Text>
      {props.filterProps.show && (
        <Tag
          statusType={StatusType.SUCCESS}
          label={props.filterProps.text}
          iconName={IconName.CHECK_MARK}
        />
      )}
    </FlexBox>
  ) : (
    <>{props.tooltipText}</>
  );
